import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function PrivacyPolicy() {
  return <div className="min-h-screen bg-[#0f1724] text-[#f5f0e8] font-sans selection:bg-[#c9a84c] selection:text-[#0f1724] py-12 px-4 md:px-8" data-id="element-269">
      <div className="max-w-3xl mx-auto" data-id="element-270">
        <Link to="/" className="inline-flex items-center gap-2 text-[#c9a84c] hover:text-[#d4af37] transition-colors mb-8" data-id="element-271">
          <ArrowLeft className="w-4 h-4" data-id="element-272" />
          Back to Home
        </Link>

        <h1 className="font-serif text-3xl md:text-4xl text-white mb-8" data-id="element-273">
          Privacy Policy
        </h1>

        <div className="space-y-6 text-[#f5f0e8]/80 leading-relaxed" data-id="element-274">
          <p data-id="element-275">Last updated: February 2025</p>

          <section className="space-y-3" data-id="element-276">
            <h2 className="text-xl text-white font-bold" data-id="element-277">1. Introduction</h2>
            <p data-id="element-278">
              Welcome to The Shadow Rental Method. We respect your privacy and
              are committed to protecting your personal data. This privacy
              policy will inform you as to how we look after your personal data
              when you visit our website and tell you about your privacy rights
              and how the law protects you.
            </p>
          </section>

          <section className="space-y-3" data-id="element-279">
            <h2 className="text-xl text-white font-bold" data-id="element-280">2. Data We Collect</h2>
            <p data-id="element-281">
              We may collect, use, store and transfer different kinds of
              personal data about you which we have grouped together follows:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-282">
              <li data-id="element-283">
                Identity Data: includes first name, last name, username or
                similar identifier.
              </li>
              <li data-id="element-284">
                Contact Data: includes billing address, delivery address, email
                address and telephone numbers.
              </li>
              <li data-id="element-285">
                Transaction Data: includes details about payments to and from
                you and other details of products and services you have
                purchased from us.
              </li>
              <li data-id="element-286">
                Technical Data: includes internet protocol (IP) address, your
                login data, browser type and version, time zone setting and
                location, browser plug-in types and versions, operating system
                and platform and other technology on the devices you use to
                access this website.
              </li>
            </ul>
          </section>

          <section className="space-y-3" data-id="element-287">
            <h2 className="text-xl text-white font-bold" data-id="element-288">
              3. How We Use Your Data
            </h2>
            <p data-id="element-289">
              We will only use your personal data when the law allows us to.
              Most commonly, we will use your personal data in the following
              circumstances:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-290">
              <li data-id="element-291">
                Where we need to perform the contract we are about to enter into
                or have entered into with you.
              </li>
              <li data-id="element-292">
                Where it is necessary for our legitimate interests (or those of
                a third party) and your interests and fundamental rights do not
                override those interests.
              </li>
              <li data-id="element-293">
                Where we need to comply with a legal or regulatory obligation.
              </li>
            </ul>
          </section>

          <section className="space-y-3" data-id="element-294">
            <h2 className="text-xl text-white font-bold" data-id="element-295">4. Data Security</h2>
            <p data-id="element-296">
              We have put in place appropriate security measures to prevent your
              personal data from being accidentally lost, used or accessed in an
              unauthorized way, altered or disclosed. In addition, we limit
              access to your personal data to those employees, agents,
              contractors and other third parties who have a business need to
              know.
            </p>
          </section>

          <section className="space-y-3" data-id="element-297">
            <h2 className="text-xl text-white font-bold" data-id="element-298">5. Contact Us</h2>
            <p data-id="element-299">
              If you have any questions about this privacy policy or our privacy
              practices, please contact us at support@shadowrentalmethod.com.
            </p>
          </section>
        </div>
      </div>
    </div>;
}